<template>
  <el-row class="bids-dop-menu">
    <el-col :span="24">
      <el-dropdown trigger="click">
        <el-button type="info" class="btn-dropdown btn-dop-menu" plain>
          доп. меню
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-if="canAction('createResponse')"
            type="text"
            @click.native="handleAddResponse"
          >
            Добавить отклик
          </el-dropdown-item>

          <choose-registry-type
            v-if="canAction('download_register') && bidsListIsReady"
            :id="currentDay.id"
            :inn="bid.user_org_inn"
            :date="dateToFormat(currentDay.load_date, 'dateForFileName')"
          />

          <send-email-button
            v-if="canAction('download_register') && bidsListIsReady"
            :id="currentDay.id"
            :inn="bid.user_org_inn"
          />
          <el-dropdown-item
            v-if="canAction('download_register') && bidsListIsReady"
            type="text"
            @click.native="handleClickDownloadReport"
          >
            Скачать файлы с отчетом ({{ selectedResponse.length }})
          </el-dropdown-item>
          <registry-pay-button
            v-if="canAction('register_payment')"
            :id="currentDay.id"
          />
        </el-dropdown-menu>
      </el-dropdown>
    </el-col>
  </el-row>
</template>

<script>
import { SET_IS_SHOW_DIALOG_SAVE_NOMENCLATURE } from '@/store/actions/loadDay'
import { mapGetters } from 'vuex'
import ChooseRegistryType from '@/components/Shared/ChooseRegistryType'
import RegistryPayButton from './RegistryPayButton'
import SendEmailButton from '@/components/Shared/SendEmailButton'

export default {
  name: 'AdditionalMenu',
  components: { ChooseRegistryType, SendEmailButton, RegistryPayButton },
  props: {
    bidsListIsReady: {
      type: Boolean,
      default: false,
    },
    bid: {
      type: Object,
      default: () => {},
    },
    currentDay: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      selectedResponse: 'loadDay/getSelected',
    }),
  },
  methods: {
    handleAddResponse() {
      if (this.currentDay.status === 1) {
        this.$alert(
          'Рассмотрите другие варианты погрузок или ожидайте пока администратор не откроет день для добора машин.',
          'День погрузки полностью укомплектован.',
          {
            confirmButtonText: 'Закрыть',
            confirmButtonClass: 'el-button--warning',
            closeOnClickModal: true,
            closeOnPressEscape: true,
            callback: () => {},
          },
        )

        return
      }
      this.$emit('dialogSelectAutoVisible')
    },
    handleClickDownloadReport() {
      this.$store.dispatch(
        `loadDay/${SET_IS_SHOW_DIALOG_SAVE_NOMENCLATURE}`,
        true,
      )
    },
  },
}
</script>

<style lang="sass">
.bids-dop-menu
  text-align: right
</style>
